// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import 'babel-polyfill'
import YDUI from 'vue-ydui'
import fastClick from 'fastclick'
import 'vue-ydui/dist/ydui.rem.css'
import 'styles/reset.css'
import 'styles/red.css'
import 'styles/blue.css'
import 'styles/black.css'
import 'styles/border.css'
import Axios from 'axios'
import plugins from './assets/js/plugins'

Vue.use(YDUI)
Vue.use(Vuex)
Vue.use(plugins)
Vue.config.productionTip = false
Vue.prototype.$axios = Axios
// Axios.defaults.baseURL = 'http://zhuzao.kechuangfu.cn:8588/jiekou/exhfair'
Axios.defaults.baseURL = 'https://member.foundry.org.cn/jiekou/exhfair'
// Axios.defaults.baseURL = 'http://meet.kechuangfu.cn:8588/jiekou/exhfair'
// Axios.defaults.baseURL = 'http://zhuzao.pq.com/jiekou/exhfair'
Axios.defaults.headers.post['Content-Type'] = 'application/json'

fastClick.attach(document.body)
const store = new Vuex.Store({
  state: {
    isLoading: false,
    isLogin: false,
    token: '',
    code: localStorage.code,
    // api_url: 'http://zhuzao.kechuangfu.cn:8588/jiekou/',
    // frontend_url: 'http://zhuzao.kechuangfu.cn:8588',
    api_url: 'https://member.foundry.org.cn/jiekou/',
    frontend_url: 'https://member.foundry.org.cn',
    // api_url: 'http://zhuzao.pq.com/jiekou/',
    // frontend_url: 'http://zhuzao.pq.com',
    uid: '',
    name: ''
  },
  mutations: {
    updateLoadingStatus(state, isLoading) {
      state.isLoading = isLoading
    },
    updateLoginStatus(state) {
      let token = localStorage.getItem('token')
      if (token && token !== 'undefined' && token !== 'null') {
        state.uid = localStorage.getItem('uid') || ''
        state.token = token
        state.name = localStorage.getItem('name') || ''
        state.isLogin = true
      } else {
        localStorage.removeItem('token')
        state.uid = ''
        state.token = ''
        state.name = ''
        state.isLogin = false
      }
    }
  }
})

router.beforeEach((route, redirect, next) => {
  /* 显示加载中动画 */
  store.commit('updateLoadingStatus', true)
  store.commit('updateLoginStatus')
  /* 路由发生变化修改页面title */
  if (route.meta.title) {
    if (route.meta.title == '问卷调查') {
    } else {
      document.title = localStorage.getItem('fair_name') ? localStorage.getItem('fair_name') : route.meta.title
    }
  }
  next()
})

router.afterEach(route => {
  /* 隐藏加载中动画 */
  store.commit('updateLoadingStatus', false)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js